module.exports = __webpack_public_path__ + "static/media/img_coaching-1.4bad7551.png";